import BottomNavigation from "./BottomNavigation";

export {
    BottomNavigation as default,
};
